module.exports = __webpack_public_path__ + "img/banner.d8e8d343.png";